import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject, forkJoin, from, of } from 'rxjs';
import { catchError, debounceTime, last, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { AiService } from 'src/app/shared/services/rest/ai.service';
import { LoadingService } from 'src/app/shared/services/rest/loading.service';
import { ParametersService } from 'src/app/shared/services/rest/parameters.service';
import { TaskService } from 'src/app/shared/services/rest/task.service';
import { SnackBarItem } from '../../../snack-bar/snack-bar-item';
import { FileService } from 'src/app/shared/services/rest/file.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-create-in-other-languages',
  templateUrl: './create-in-other-languages.component.html',
  styleUrls: ['./create-in-other-languages.component.scss']
})
export class CreateInOtherLanguagesComponent extends BaseClass implements OnInit, OnDestroy {
  public isSubmit: boolean = false;
  public target_language: any[] = [];
  
  public ai_model: FormControl = new FormControl();
  
  public models$: ReplaySubject<any> = new ReplaySubject<any>(1);
  public aiModelControl: FormControl = new FormControl();
  public models;

  public langs: any;
  public langsControl: FormControl = new FormControl();
  public langs$: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateInOtherLanguagesComponent>,
    private fileService: FileService,
    private ls: LoadingService,
    private companyService: CompanyService,
    private layoutService: LayoutService,
    private aiService: AiService,
    private parametersService: ParametersService,
  ) { super() }

  ngOnInit(): void {
    console.log("data", this.data)
    this.attachSubscriptions(
      this.langsControl.valueChanges.pipe(debounceTime(300)).subscribe((resp) => this.onSearchLang(resp))
    )
    this.attachSubscriptions(
      this.aiModelControl.valueChanges.pipe(debounceTime(300)).subscribe((resp) => this.onSearchAiModels(resp))
    )
    this.getLangs();
    this.getAIModels();
  }

  onSearchAiModels(resp) {
    if (!this.models) {
      return;
    }

    if (!resp) {
      this.models$.next(this.models.slice());
      return;
    } else {
      resp = resp.toLowerCase();
    }

    // filter the banks
    this.models$.next(
      this.models.filter(b => b.name.toLowerCase().indexOf(resp) > -1)
    );
  }
  
  getAIModels() {
    this.attachSubscriptions(
      this.aiService.getAIModels().subscribe(resp => {
        this.models = resp.filter(k => !k.is_text_to_speech);
        this.models$.next(this.models.slice());

        if (this.models.length) {
          let model_id = this.models[0].id;
          if (this.models.find(k => k.id == 1)) {
            model_id = this.models.find(k => k.id == 1).id
          }
          this.ai_model.patchValue(model_id)
        }
      })
    )
  }

  getLangs() {
    let filter:any = {is_language: 1};
    if (this.data.file.company_id != this.data.company.id) {
      filter.partner_company_id = this.data.file.company_id;
    }
    this.attachSubscriptions(
      this.parametersService.getAllValues(1, this.data.company.id, filter, '200').pipe(
        map(res => res.body),
        tap(res => {
          this.langs = res;
          this.langs$.next(this.langs.filter(x => !!x.id).slice())
        }),
      ).subscribe(resp => {
        console.log("this.langs", this.langs)
      })
    )
  }

  getLangByVal(value) {
    return this.langs && this.langs.find(x => x.value == value)
  }

  onSearchLang(resp) {
    if (!this.langs) {
      return;
    }

    if (!resp) {
      this.langs$.next(this.langs.filter(z => !!z.id).slice());
      return;
    } else {
      resp = resp.toLowerCase();
    }
    // filter the banks
    this.langs$.next(
      this.langs.filter(z => !!z.id && (z.value.toLowerCase().indexOf(resp) > -1))
    );
  }

  isChecked(): boolean {
    return this.target_language && this.langs && this.langs.length
      && this.target_language.length === this.langs.length;
  }

  isIndeterminate(): boolean {
    return this.target_language && this.langs && this.langs.length && this.target_language.length
      && this.target_language.length < this.langs.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    console.log('change', change)
    console.log("this.langs", this.langs);
    if (change.checked) {
      this.target_language = this.langs.map(x => x.value)
    } else {
      this.target_language = []
    }

  console.log("this.target_language", this.target_language);

  }
  

  log() {
    console.log('this.target_language', this.target_language)
  }

  close() {
    this.dialogRef.close({event: "close", data: false})
  }

  save() {
    this.isSubmit = true;
    
    let jsonObj:any;
    if (this.data.normalDoc) {
      jsonObj = {
        docName: this.data.file.document.name,
        text: this.data.file.document.text
      }
    } else {
      let parsedVal = JSON.parse(this.data.file.document.text);
      jsonObj = {
        docName: this.data.file.document.name,
        name: parsedVal.name,
        desc: parsedVal.desc
      }
    }

    let langsArr = [];

    this.target_language.forEach((lang) => {
      let x:any = {
        language: lang,
        company_id: this.data.company.id,
        partner_company_id: this.data.company.id != this.data.file.company_id ? this.data.file.company_id : 0,
        messages: [
          {
            content: `Translate this object values to ${lang} language. Return only new language object.`,
            role: 'developer',
          },
          {
            role: 'user',
            content: JSON.stringify(jsonObj)
          }
        ],
        model: this.ai_model.value
      }

      langsArr.push(x)
    })
    // "Translate array of massages to en languge. Return array";

    // this.isGettingTranslations = true;

    let count = 0;
    let lenSelection = langsArr.length;

    if (!lenSelection) {
      this.layoutService.showSnackBar({name: 'No Jobs'}, '', SnackBarItem)
      return
    }
    this.isSubmit = true;

    this.ls.requests$.next({
      value: 0,
      target: `Translate document to ${lenSelection} languages`
    })

    let target:any = {
      task_id: this.data.file.task_id,
      task_operation_id: this.data.file.task_operation_id,
      discussion_id: this.data.file.discussion_id,
      file_id: this.data.file.file_id,
    };

    from(langsArr).pipe(
      mergeMap((langData) => {
        let sendData = {...langData}
        delete sendData.language
        return this.aiService.sendAIMsg(sendData).pipe(
          map(answer => {
            console.log("answer", answer)
            try {
              // Извлечение JSON из текста
              let jsonMatch = answer.match(/\{([\s\S]*?)\}/); // Альтернатива без флага 's'
              if (jsonMatch) {
                  let jsonString = jsonMatch[0].trim(); // Сам JSON
                  let parseAnswer = JSON.parse(jsonString); // Парсим JSON
                  console.log('Parsed data:', parseAnswer);
                  return parseAnswer;
              } else {
                  console.error('No JSON array found in the response');
                  return {}
              }
            } catch (error) {
              return {}
            }
          }),
          switchMap(answerData => {
            if (answerData.docName) {
              return this.fileService.uploadFile({
                company_id: this.data.file.company_id,
                task_id: this.data.file.task_id,
                task_operation_id: this.data.file.task_operation_id,
                filename: this.data.file.filename + "_" + (this.getLangByVal(langData.language).iso_value ? this.getLangByVal(langData.language).iso_value : this.getLangByVal(langData.language).value),
                location: this.data.file.location,
                is_document: 1,
                content_type: this.data.normalDoc ? '' : 'reports-json-auto-post',
              }, this.data.company.id).pipe(
                switchMap(newFile => {
                  return this.fileService.createFileRelation({
                    company_id: this.data.file.company_id,
                    file_id: this.data.file.id,
                    related_file_id: newFile.id
                  }, this.data.company.id).pipe(
                    catchError(() => {
                      return of(newFile)
                    }),
                    map(() => newFile)
                  )
                }),
                switchMap(newFile => {
                  return this.parametersService.addTargetParameter({
                    company_id: newFile.company_id,
                    parameter_id: this.getLangByVal(langData.language).parameter_id,
                    parameter_value_id: this.getLangByVal(langData.language).id,
                    task_id: newFile.task_id,
                    task_operation_id: newFile.task_operation_id,
                    discussion_id: newFile.discussion_id && newFile.discussion ? newFile.discussion_id : 0,
                    file_id: newFile.id,
                    is_primary: 1
                  }, this.data.company.id).pipe(
                    catchError(() => {
                      return of(newFile)
                    }),
                    map(() => newFile)
                  )
                }),
                switchMap((newFile) => {
                  let fil = JSON.parse(JSON.stringify(target))
                  delete fil.file_id
                  delete fil.discussion_id
                  return this.fileService.getFilesProgress(this.data.company.id, [newFile.id], fil).pipe(
                    map((files) => files[0]),
                  )
                }),
                switchMap(progressFile => {
                  target.file_id = progressFile.id
                  console.log("SWITCH FILE", progressFile)
                  return this.companyService.editNote(progressFile.document.id, {
                    name: answerData.docName, 
                    text: this.data.normalDoc ? answerData.text : JSON.stringify({
                      name: answerData.name,
                      desc: answerData.desc
                    })
                  }, this.data.company.id, target).pipe(
                    switchMap(() => {
                      let fil = JSON.parse(JSON.stringify(target))
                      delete fil.file_id
                      delete fil.discussion_id
                      return this.fileService.getFilesProgress(this.data.company.id, [progressFile.id], fil, ',parameterValuesToTask.parameter,parameterValuesToTask.parameterValue')
                    }),
                    map((endFiles) => endFiles[0]),
                    tap(k => {
                      if (this.data.files) {
                        this.data.files.push(k)
                      }
                      this.ls.requests$.next({
                        value: Math.round((100 / lenSelection) * (count+1)),
                        target: `Translate document to ${lenSelection} languages`
                      })
                      count++;
                    })
                  )
                })
              )
            } else {
              this.ls.requests$.next({
                value: Math.round((100 / lenSelection) * (count+1)),
                target: `Translate document to ${lenSelection} languages`
              })
              count++;
              return of(answerData)
            }
          })
        )
      }, 2),
    ).subscribe(resp => {
      this.close();
      console.log('from(langsArr) resp', resp);
    })
  }


  ngOnDestroy(): void {
    this.clearSubscriptions()
  }
}
